import React, { useState, useEffect, Suspense } from 'react';

export function asyncWrapper(Component, keyCalculator, fallback = <></>) {
  const SuspendedContent = ({ ...props }) => {
    if (!props.key && keyCalculator) props.key = keyCalculator(props);

    // Will be fixed, used for event loop synchronization (but bad practice)
    const [locked, setLocked] = useState(true);
    useEffect(() => { setLocked(false); }, []);

    return (
      <Suspense fallback={fallback}>
        {!locked && <Component {...props} />}
      </Suspense>
    );
  };

  return SuspendedContent;
}
